import {h, Fragment} from "preact"
import { useProductFilters } from "@nosto/preact"

export default function SelectedFilters() {
    const { filters, removeAll } = useProductFilters();

    const handleRemoveFilter = (filter) => {
        filter.remove();
        const matchingFilter = filters.find(f => f.field === 'extra.custom-color_cr' && f.value === filter.value.toUpperCase());
        if(matchingFilter) {
            matchingFilter.remove();
        }
    }
    
    return (filters.length > 0 && (
        <div className="ns-active-filters">
            <div className="ns-active-filters__list ns-mobile-hidden">
                {filters.map((filter) => {
                    if(
                        filter.field !== 'extra.custom-color_cr' || 
                        filter.field === 'extra.custom-color_cr' && 
                        filter.value !== filter.value.toUpperCase()
                    ) {
                        return (
                            <button
                                class="ns-active-filters__item"
                                key={filter.value}
                                type="button"
                                onClick={() => handleRemoveFilter(filter)}
                                aria-label={`Remove ${filter.value} filter`}
                            >
                                <span>{filter.name}: {filter.value}</span>
                                <svg aria-hidden="true" focusable="false" width="12" height="13" class="icon icon-close-small" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M8.48627 9.32917L2.82849 3.67098" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path>
                                    <path d="M2.88539 9.38504L8.42932 3.61524" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path>
                                </svg>
                            </button>
                        )
                    }
                })}
            </div>
            <button
                class="ns-active-filters__clear-all"
                type="button"
                aria-label="Clear all filters"
                onClick={removeAll}
            >
                Clear All
            </button>
        </div>
    ))
}
